<template>
  <div class="g-content g-filter">
    <!-- 搜索 -->
    <div class="g-content-filter">
      <div class="g-content-filter-main">
        <h3>
          <span>{{ $t('configModel_group_title') }}</span>
        </h3>

        <div class="search">
          <router-link to="/manage/system/config-model/list" style="margin-left:15px">
            <a-button type="dashed" size="small" icon="double-left">
              {{ $t('com_btn_back') }}
            </a-button>
          </router-link>
        </div>
      </div>
    </div>
    <Loading :show="loading" v-if="loading" />
    <NetworkError v-else-if="networkError" style="margin-top:0;" />
    <div class="g-content-main common-filter-main config-group-main" v-else>
      <div class="config-group-title">
        <!-- <a-button
          type="danger"
          size="small"
          @click="deleteBatchGroup"
          v-if="groupList && groupList.length"
          icon="delete"
          v-auth="['auth_dict_group_delete_batch']"
          :disabled="!selectedRowKeys.length"
        >
          {{ $t('com_btn_delete_batch') }}
        </a-button> -->

        <a-button
          type="primary"
          size="small"
          @click="$refs.configGroupUpdate.show('add')"
          icon="plus"
          v-auth="['auth_dict_group_add']"
        >
          {{ $t('configModel_btn_add_group') }}
        </a-button>
      </div>

      <div class="g-table config-model-group-table">
        <a-table
          :columns="columns"
          :data-source="groupList"
          :pagination="false"
          :rowKey="(_text, index) => _text.groupId"
          bordered
        >
          <!-- 名称 -->
          <template slot="Name" slot-scope="text, record">
            <div
              @click="$refs.configGroupUpdate.show('edit', record)"
              style="text-decoration: underline;cursor: pointer;"
              v-if="authList.includes('auth_dict_group_edit') || isSuperAdmin"
            >
              {{ text }}
            </div>
            <div v-else>{{ text }}</div>
          </template>

          <!-- 创建更新时间 -->
          <template slot="createTime" slot-scope="text">
            {{ text | formatDate }}
          </template>

          <!-- 操作 -->
          <template slot="Action" slot-scope="text, record">
            <a-button
              type="primary"
              size="small"
              @click="$refs.configGroupUpdate.show('edit', record)"
              icon="edit"
              v-auth="['auth_dict_group_edit']"
            >
              {{ $t('com_btn_edit') }}
            </a-button>

            <a-button
              type="danger"
              size="small"
              @click="deleteGroup(record)"
              icon="delete"
              v-auth="['auth_dict_group_delete']"
            >
              {{ $t('com_btn_delete') }}
            </a-button>
          </template>
        </a-table>
      </div>
    </div>

    <!-- 添加/编辑 -->
    <ConfigUpdate ref="configGroupUpdate" :callback="getGroupList" :menu="currentMenuInfo" />
  </div>
</template>
<script>
import * as API from '@/api/system/config';
import ConfigUpdate from './update.vue';
import { makeTree } from '@/libs/utils';
import { mapGetters } from 'vuex';

export default {
  components: {
    ConfigUpdate,
  },
  data() {
    return {
      form: {},
      rules: {},
      groupList: [],
      // 当前菜单信息
      currentMenuInfo: null,
      loading: true,

      // infterface表头
      columns: [
        {
          title: this.$t('com_table_id'),
          align: 'center',
          dataIndex: 'groupId',
          width: 60,
        },
        {
          title: this.$t('configModel_table_group_name'),
          dataIndex: 'groupName',
          scopedSlots: { customRender: 'Name' },
        },

        {
          title: this.$t('com_form_description'),
          dataIndex: 'description',
        },

        {
          title: this.$t('com_table_created_time'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
      ],

      selectedRowKeys: [],

      networkError: false,
    };
  },
  computed: {
    ...mapGetters(['authList', 'isSuperAdmin']),
    hasSelected() {
      return this.selectedRowKeys.length > 0;
    },
  },

  created() {
    // 权限操作
    if (
      this.authList.includes('auth_dict_group_edit') ||
      this.authList.includes('auth_dict_group_delete') ||
      this.isSuperAdmin
    ) {
      this.columns.push({
        title: this.$t('com_table_operation'),
        dataIndex: 'Action',
        scopedSlots: { customRender: 'Action' },
      });
    }

    this.getGroupList();
  },
  methods: {
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },

    // 获取菜单列表
    getGroupList() {
      this.networkError = false;
      API.ConfigGroupList()
        .then(res => {
          try {
            const treeObj = makeTree({ data: res.data || [] });
            this.groupList = treeObj.array;
          } catch (err) {
            console.log('err', err);
          }
        })
        .catch(() => {
          this.networkError = true;
        })
        .finally(() => {
          this.$store.commit('setPageLoading', false);
          this.loading = false;
        });
    },

    // delete
    deleteGroup(record) {
      const _this = this;
      const h = this.$createElement;
      this.$confirm({
        title: this.$t('configmModel_confirm_delete_group'),
        content: h('div', {}, [
          h(
            'p',
            this.$t('configmModel_confirm_delete_group_content', {
              name: record.groupName,
            })
          ),
        ]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.ConfigGroupDelete({ gId: record.groupId })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getGroupList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },

    // batch delete
    deleteBatchGroup() {
      if (!(this.selectedRowKeys && this.selectedRowKeys.length)) {
        this.$message.error(this.$t('com_msg_select_group_first'));
        return;
      }

      const _this = this;
      const h = this.$createElement;
      this.$confirm({
        title:
          this.selectedRowKeys.length > 1
            ? this.$t('configmModel_confirm_delete_some_group_title')
            : this.$t('configmModel_confirm_delete_group_title'),
        content: h('div', {}, [
          h(
            'p',
            this.$t('configmModel_confirm_delete_group_content_ids', {
              ids: this.selectedRowKeys,
            })
          ),
        ]),
        centered: true,
        onOk: () => {
          this.deleteLoading = true;
          this.$store.commit('setFreeze', this.$t('com_ongoing_delete'));
          API.ConfigGroupDeleteBatch({ groupIds: this.selectedRowKeys })
            .then(res => {
              if (res.code === 0) {
                this.$message.success(this.$t('com_msg_delete_success'));

                // 重新获取列表
                this.getGroupList();
              }
            })
            .finally(() => {
              this.$store.commit('setFreeze', false);
            });
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.search {
  display: flex;
  align-items: center;
}
.g-content {
  .config-group-main {
    height: 100%;
    position: relative;
    .config-group-title {
      position: absolute;
      button {
        margin-right: 15px;
      }
    }
  }
  .g-table.config-model-group-table {
    flex: 1;
    margin-top: 36px;
    height: calc(100% - 36px);
    overflow-y: auto;
  }
}
</style>
